import { fetcherAmplify } from 'src/business/Libraries/Fetcher';
import QuizRepositoryImpl from './QuizRepositoryImpl';

const quizRepository = new QuizRepositoryImpl(fetcherAmplify);
export { quizRepository };
